/**
 * ReferralsDisabledNotice
 * Shown wherever a referrer would otherwise start or submit a referral, while
 * self-generated referrals are switched off. Text comes from the backend
 * (see utils/referrerPortalStatus).
 */

import React from 'react';
import { Info } from 'lucide-react';

function ReferralsDisabledNotice({ notice, style = {} }) {
  if (!notice) return null;

  return (
    <div
      role="status"
      style={{
        backgroundColor: '#fff8e1',
        border: '1px solid #ffe0a3',
        borderLeft: '4px solid #e8941c',
        borderRadius: 8,
        padding: '18px 20px',
        display: 'flex',
        gap: 14,
        alignItems: 'flex-start',
        ...style,
      }}
    >
      <Info size={20} color="#e8941c" style={{ flexShrink: 0, marginTop: 2 }} />
      <p style={{ margin: 0, fontSize: 14, lineHeight: 1.6, color: '#5c4813' }}>
        {notice}
      </p>
    </div>
  );
}

export default ReferralsDisabledNotice;
